import React from 'react';
import {message, useIntl} from '@sail/intl';

import {ScreenContentLayout} from 'src/return/ScreenContentLayout';
import {useSelector} from 'src/return/state/store';
import {ProgressHeader} from 'src/v2/components/anyCrypto/progress/ProgressHeader';
import {ProgressStatusIcon} from 'src/v2/components/anyCrypto/progress/ProgressStatusIcon';
import {VARIANT_STYLES} from 'src/v2/components/anyCrypto/progress/progressVariant';

const messages = {
  title: message({
    id: 'crypto.payins.return.complete.title',
    description: 'Title of the completed refund address collection screen',
    defaultMessage: 'Refund address submitted.',
  }),
  description: message<{
    merchantName: string;
    walletAddress: string;
  }>({
    id: 'crypto.payins.return.complete.description',
    description:
      'Confirmation that the merchant will send the refund to the submitted wallet address',
    defaultMessage:
      '{merchantName} will send your refund to the wallet address {walletAddress}.',
  }),
};

export const ReturnCompleteScreen = (): React.ReactElement => {
  const intl = useIntl();
  const merchantName = useSelector(
    (state) => state.merchantBranding.merchantName,
  );
  const submittedWalletAddress = useSelector(
    (state) => state.submittedWalletAddress,
  );

  return (
    <ScreenContentLayout>
      <ProgressStatusIcon statusIconVariant={VARIANT_STYLES.success} />
      <ProgressHeader
        title={intl.formatMessage(messages.title)}
        subtitle={intl.formatMessage(messages.description, {
          merchantName,
          walletAddress: submittedWalletAddress!,
        })}
      />
    </ScreenContentLayout>
  );
};
